import { SettingItem, TipItem } from './index.d';
import iconWater from './images/icon_location_water.png';
import iconNetWork from './images/icon_location_network.png';
import iconStation from './images/icon_location_station.png';
import iconYulei from './images/icon_location_yulei.png';


export const settingList: SettingItem[] = [
  {
    value: false,
    title: '智能安全守护',
    desc: '系统智能识别特殊地点，孩子驻留时，家长收到通知'
  }
]

export const areaTipItems: TipItem[] = [
  {
    icon: iconWater,
    title: '水域',
    desc: '河流、海边、池塘、湖泊、古井',
    isLast: false,
    isFirst: true
  },
  {
    icon: iconNetWork,
    title: '网络',
    desc: '网吧、网咖、游戏厅',
    isLast: false,
    isFirst: false
  },
  {
    icon: iconStation,
    title: '车站',
    desc: '汽车车站、火车车站、机场',
    isLast: false,
    isFirst: false
  },
  {
    icon: iconYulei,
    title: '娱乐场所',
    desc: 'KTV、酒吧、棋牌室、台球室、舞厅等',
    isLast: true,
    isFirst: false
  },
]